import DuplicatePage from './DuplicatePage';

export default DuplicatePage;